import Jump from 'src/pages/Jump'
import Err from 'src/pages/Err'
import Home from 'src/pages/home/Home'
import myRouter from './MyRouterResolver'
import Login from 'src/pages/Login'
import packageRouter from './package.router'
import catalogsRouter from './catalogs.router'
import deviceRouter from './device.router'

let router = myRouter()
router.addComponent('', Login)
router.addComponent('jump', Jump)
router.addComponent('error', Err, {
  /* modules: ['dialog']*/
})
// modules: ['pull-to-refresh', 'tabs']
router.addComponent('home', Home, {
  modules: ['tabs', 'pull-to-refresh', 'typography', 'accordion', 'radio', 'input', 'chip'],
})
router.use('/package', packageRouter)
router.use('/catalogs', catalogsRouter)
router.use('/device', deviceRouter)
let routerResolveAll = router.resolverAll()
export default routerResolveAll
